import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { Store } from '@ngxs/store';
import { GpAsteriskState, GpCallMetaModel } from 'gp-asterisk';
import { addIcons } from 'ionicons';
import { call, cellularOutline, chevronDown, locationOutline, mic, micOff, documentTextOutline, volumeHigh, volumeMedium } from 'ionicons/icons';
import { combineLatest, map, timer } from 'rxjs';
import { SoftphoneService } from './softphone.service';

addIcons({ call, cellularOutline, chevronDown, locationOutline, mic, micOff, documentTextOutline, volumeHigh, volumeMedium });

// останні 9 цифр — однаково для 0XXXXXXXXX, +380XXXXXXXXX і 380XXXXXXXXX
const phoneKey = (phone?: string | null) => (phone || '').replace(/\D/g, '').slice(-9);

// Екран дзвінка вбудованого телефону: повноекранний або згорнутий у смужку зверху
@Component({
  selector: 'mobile-softphone-call',
  standalone: true,
  imports: [IonicModule, AsyncPipe],
  templateUrl: './softphone-call.component.html',
  styleUrl: './softphone-call.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SoftphoneCallComponent {
  readonly state$ = this.softphone.state$;
  readonly minimized$ = this.softphone.minimized$;

  // дані клієнта з CRM: про кожен дзвінок клієнта бекенд надсилає картку (ім'я, адреса, останній документ)
  readonly crm$ = combineLatest([this.softphone.state$, this.store.select(GpAsteriskState.callList)]).pipe(
    map(([state, calls]) => {
      const key = phoneKey(state.call?.number);
      if (!key) return null;
      return (calls as GpCallMetaModel[]).find(c => phoneKey(c.phone) === key) ?? null;
    })
  );

  // таймер розмови, оновлюється щосекунди
  readonly elapsed$ = timer(0, 1000).pipe(map(() => {
    const startedAt = this.softphone.state$.value.call?.startedAt;
    if (!startedAt) return '';
    const sec = Math.floor((Date.now() - startedAt) / 1000);
    return `${String(Math.floor(sec / 60)).padStart(2, '0')}:${String(sec % 60).padStart(2, '0')}`;
  }));

  constructor(readonly softphone: SoftphoneService, private store: Store) {}

  initials(name: string): string {
    return name.split(/\s+/).filter(Boolean).slice(0, 2).map(part => part[0]).join('').toUpperCase();
  }
}
